<template>
  <div class="p-honoraryAwards">
    <div class="__ban kf-animate kf-animate-img">
      <div class="__ban_cap">荣誉奖项</div>
    </div>
    <div class="g-box">
      <div class="__list">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="__list_item"
          :style="{
            backgroundImage: 'url(' + item.image + ')',
          }"
        >
          <div class="__list_text">{{ item.title }}<br />{{ item.tips }}</div>
        </div>
      </div>

      <!--分页-->
      <el-pagination
        class="kf-pagination"
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        @current-change="onCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";

export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {
    init() {
      this.params = this.$route.params;
      this.pageNum = 1;
      this.getAjax();
    },
    getAjax() {
      this.getList();
    },
  },
};
</script>
<style lang="less">
.p-honoraryAwards {
  padding-bottom: 120px;
  .__ban {
    background: url("../../assets/img/ico_6.png") no-repeat;
    background-size: cover;
    height: 280px;
    display: flex;
  }
  .__ban_cap {
    margin: auto;
    font-size: 60px;
    color: #ffffff;
    line-height: 84px;
    letter-spacing: 0.7em;
  }
  .__list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 40px;
  }
  .__list_item {
    flex-shrink: 0;
    width: 340px;
    height: 240px;
    margin-right: 40px;
    margin-top: 40px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
    overflow: hidden;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      .__list_text {
        top: 0;
      }
    }
  }
  .__list_text {
    position: absolute;
    left: 0;
    top: -100%;
    width: 100%;
    height: 100%;
    background: rgba(0, 48, 170, 0.8);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 61px;
    text-align: center;
    font-size: 18px;
    color: #ffffff;
    line-height: 32px;
    transition: top 0.2s;
  }
  .kf-pagination {
    margin-top: 60px;
    text-align: center;
  }
}
</style>
